<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div class="py-6">
      <p class="text-black-10 font-normal text-base px-7 pb-7">
        Save Beneficiary
      </p>
      <hr />
      <div class="pt-5 px-7">
        <p class="text-fg-muted font-normal text-11px mb-2">Beneficiary Name</p>
        <p class="text-black-10 text-base font-bold mb-6">
          {{ singlePayoutDetails.attributes.details.accountName }}
        </p>
        <el-form>
          <div class="px-5">
            <el-form-item prop="useNickname">
              <el-radio label="useNickname" v-model="beneficiary.useNickName"
                >Use Nickname</el-radio
              >
            </el-form-item>
            <el-form-item prop="nickName" v-if="beneficiary.useNickName">
              <el-input
                type="text"
                prop="nickName"
                name="nickName"
                placeholder="Enter a Nickname"
                v-model="beneficiary.nickName"
              >
              </el-input>
            </el-form-item>
          </div>
          <o-button
            class="rounded-md text-sm font-normal mt-8"
            @click="saveBeneficiary"
            :loading="isLoading"
            >{{ isLoading ? 'Saving' : 'Save' }}</o-button
          >
          <el-button
            class="border-none flex justify-center bg-white w-full py-3.5 text-primary rounded-md text-sm font-normal mt-1 hover:bg-white hover:text-primary"
            @click="handleClose"
          >
            Cancel
          </el-button>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      // TODO move beneficiary
      beneficiary: {
        useNickName: false,
        nickName: ''
      },
      breakpoints
    }
  },
  components: {},
  methods: {
    clearBulkPayoutState () {
      this.$store.dispatch('bulkPayout/resetBulkPayoutState')
    },
    handleClose () {
      this.$emit('closeDialog')
      this.clearSelectedBeneficiary()
      this.$store.dispatch('bulkPayout/resetBulkPayoutState')
    },
    clearSelectedBeneficiary () {
      this.$store.dispatch('bulkPayout/setBeneficiaryDetails', null)
    },
    addIntermediaryBankDetailsPayload () {
      if (this.singlePayoutDetails.attributes.details?.intermediaryBank) {
        const { bankAddress, bankName, reference, swiftCode } =
          this.singlePayoutDetails.attributes.details?.intermediaryBank
        return {
          bankName: bankName,
          bankAddress: bankAddress,
          swiftCode: swiftCode,
          reference: reference
        }
      }
      return null
    },
    saveBeneficiary () {
      const currency = this.singlePayoutDetails.attributes.amount.currency
      const intermediaryBank = this.addIntermediaryBankDetailsPayload()
      const payloadForOtherCurrencies = {
        destinationCurrency: currency,
        nickname: this.beneficiary.nickName || '',
        personalDetails: {
          name: this.selectedBeneficiary.accountName,
          country:
            this.selectedBeneficiary.recipientCountry ||
            this.selectedBeneficiary.country ||
            '',
          city:
            this.selectedBeneficiary.recipientCity ||
            this.selectedBeneficiary.city ||
            '',
          address:
            this.selectedBeneficiary?.recipientAddress ||
            this.selectedBeneficiary?.district
        },
        bankDetails: {
          bankCode: this.singlePayoutDetails.attributes.details.bankCode || '',
          accountNumber:
            this.selectedBeneficiary.accountNumber ||
            this.selectedBeneficiary.accountNo,
          routingNumber: this.selectedBeneficiary.routingNo,
          swiftCode: this.selectedBeneficiary.swiftCode || '',
          bankName: this.selectedBeneficiary.bankName,
          accountName: this.selectedBeneficiary.accountName,
          country: this.selectedBeneficiary.bankCountry,
          isWithinUs:
            this.selectedBeneficiary.bankCountry === 'US' ? 'yes' : 'no',
          city: this.selectedBeneficiary.bankCity,
          bankAddress: this.selectedBeneficiary.bankAddress,
          district: this.selectedBeneficiary.district,
          postalCode: this.selectedBeneficiary.bankPostalCode
        },
        intermediaryBank
      }
      // BE requires that personalDetails should not be sent at all if the currency is NGN
      const NGNPayload = { ...payloadForOtherCurrencies }
      delete NGNPayload.personalDetails
      this.isLoading = true
      this.$store
        .dispatch(
          'bulkPayout/saveBeneficiary',
          currency === this.$CURRENCY.NGN
            ? NGNPayload
            : payloadForOtherCurrencies
        )
        .then(() => {
          this.isLoading = false
          // clear bulk payout state
          this.clearBulkPayoutState()
          this.handleClose()
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  computed: {
    singlePayoutDetails () {
      return this.$store.state.bulkPayout.currentBulkPayoutDetails || {}
    },
    selectedBeneficiary () {
      return this.$store.state.bulkPayout.beneficiaryDetails || {}
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
* >>> .el-dialog {
  border-radius: 16px;
  background-color: white;
}

* >>> .el-dialog__close::before,
.el-dialog__close::after {
  color: var(--foreground-default) !important;
}

* >>> .el-dialog__header {
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
}

* >>> .el-dialog__title {
  color: var(--foreground-default);
  font-weight: 600;
  font-size: 20px;
}

* >>> .el-input__inner {
  background: var(--input-background);
  color: var(--input-text);
  height: 55px;
  border-radius: 8px;
}

* >>> .el-form-item__label {
  color: var(--input-text);
  font-weight: 400;
}

* >>> .el-form-item {
  margin-bottom: 12px;
}

* >>> .el-dialog__body {
  padding: 0;
}
</style>
